import { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./styles.css";
import "react-tabs/style/react-tabs.css";
import { Link } from "react-router-dom"; // Substituído useNavigate por Link
import api from "../../services/api";
import { Button } from "../../components/ui/button";

export default function Usuarios({ termoPesquisa }) {
  const [usuarios, setUsuarios] = useState([]);

  const [isGestorDeProjetos, setIsGestorDeProjetos] = useState("");

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        let token = localStorage.getItem("auth-token");
        const response = await api.get("/api/user/perfil", { headers: { "x-auth-token": token } });
        const userData = response.data;
        setIsGestorDeProjetos(userData.isProjectManager);
      } catch (error) {
        console.error("Erro ao buscar informações do usuário:", error);
      }
    };

    getUserInfo();
  }, []);

  const buscarUsuarios = async () => {
    try {
      const response = await api.get("/api/buscarUsuarios");
      setUsuarios(response.data);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
    }
  };

  useEffect(() => {
    buscarUsuarios();
  }, []);

  const usuariosFiltrados = usuarios.filter((usuario) => {
    return (
      usuario?.name?.toLowerCase()?.includes(termoPesquisa?.toLowerCase()) ||
      usuario?.nome_usuario?.toLowerCase()?.includes(termoPesquisa?.toLowerCase())
    );
  });

  const customRowStyle = {
    "&:last-child td": {
      borderBottom: "none",
    },
  };

  const columns = [
    {
      field: "name",
      header: () => (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 280,
              marginLeft: "10px",
              textAlign: "initial",
            }}
          >
            <span className="text-xl text-900 mr-4" style={{ fontStyle: "bold" }}>
              Nome
            </span>
            <span className="text-xl text-900 mr-4">Username</span>
            <span className="text-xl text-900 mr-4">Email do Usuário</span>
          </div>
        </div>
      ),
      body: (usuario) => (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
          <div style={{ display: "flex", flexDirection: "row", marginLeft: "10px", alignItems: "center" }}>
            <span style={{ width: "150px" }} className="text-xl ">
              {usuario.name}
            </span>
            <div style={{ display: "flex", flexDirection: "row", marginLeft: "200px", width: "150px" }}>
              <span className="text-xl ">{usuario.nome_usuario}</span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "150px",
                marginLeft: "230px",
              }}
            >
              <span className="text-xl ">{usuario.email}</span>
            </div>

            <div style={{ width: "150px", marginLeft: "220px" }}>
              {isGestorDeProjetos ? (
                <Link to={`/editar-usuario/${usuario.id}`}>
                  <Button variant="outline">Editar</Button>
                </Link>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="w-full">
      <DataTable
        className="custom-data-table"
        value={usuariosFiltrados}
        stripedRows
        style={{
          border: "1px solid #E4E4E7",
          fontWeight: "400",
          color: "#000!important",
          borderWidth: "1px 1px 0px 1px",
        }}
        scrollable
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
      >
        {columns.map((col, i) => (
          <Column key={col.field} field={col.field} header={col.header} body={col.body} rowStyle={customRowStyle} />
        ))}
      </DataTable>
    </div>
  );
}
